import p from './account-manage.vue';

export default p;
